import { Link } from "react-router-dom";
import { Utensils, Coffee, Wheat, Wallet, Settings2, ArrowRight, ArrowLeft } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useSiteImages } from "../hooks/use-site-images";

const PACKAGE_ICONS = [Utensils, Coffee, Wheat, Wallet, Settings2];
const PACKAGE_IMAGES = [
  "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1447933601403-0c6688de566e?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&w=800&q=80",
];

export function PackagesSection() {
  const { t, isRTL } = useLang();
  const Arrow = isRTL ? ArrowLeft : ArrowRight;
  const siteImage = useSiteImages();

  return (
    <section className="py-20 bg-white" data-testid="packages-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-12">
          <div className="max-w-xl">
            <div className="inline-block text-[10px] tracking-[0.3em] text-[#ef4444] font-semibold mb-3 uppercase">
              {t.packages.eyebrow}
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0891b2] mb-3 leading-tight">
              {t.packages.title}
            </h2>
            <p className="text-slate-600">{t.packages.subtitle}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {t.packages.items.map((p, i) => {
            const Icon = PACKAGE_ICONS[i] || Utensils;
            return (
              <Link
                key={i}
                to="/quote"
                data-testid={`package-${i}`}
                className="group relative overflow-hidden rounded-xl border border-slate-200 hover:border-[#ef4444] transition-all bg-white hover:shadow-xl"
              >
                <div className="aspect-[4/3] overflow-hidden bg-slate-100">
                  <img
                    src={siteImage(`home_package_${i + 1}`, PACKAGE_IMAGES[i])}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a] via-[#0f172a]/40 to-transparent" />
                  <div className="absolute top-3 start-3 w-9 h-9 bg-[#ef4444] rounded-lg flex items-center justify-center shadow-lg">
                    <Icon className="w-4.5 h-4.5 text-white" />
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-display text-base text-[#0891b2] mb-1.5 leading-tight">{p.title}</h3>
                  <p className="text-slate-600 text-xs leading-relaxed mb-4 min-h-[48px]">{p.text}</p>
                  <div className="inline-flex items-center gap-1.5 text-[#ef4444] text-xs font-semibold uppercase tracking-wider">
                    {t.packages.cta}
                    <Arrow className="w-3.5 h-3.5 group-hover:translate-x-1 rtl:group-hover:-translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
